// Mock IDs for testing parameter validation - valid examples
export const VALID_TEST_IDS = {
  eventId: '12345',
  organizationId: '56789',
  userId: '45678',
};

// Mock IDs for testing parameter validation - invalid examples
export const INVALID_TEST_IDS = {
  eventId: '',
  organizationId: undefined,
  userId: null,
};
